var map = {
	"./bn.json": [
		5270,
		270
	],
	"./bn_BD.json": [
		4614,
		614
	],
	"./en.json": [
		6443
	],
	"./es.json": [
		5117,
		117
	],
	"./fr.json": [
		6115,
		115
	],
	"./he.json": [
		357,
		357
	],
	"./hi.json": [
		2686,
		686
	],
	"./it.json": [
		9399,
		399
	],
	"./nl.json": [
		3573,
		573
	],
	"./pl.json": [
		8130,
		130
	],
	"./ru.json": [
		482,
		482
	],
	"./tr.json": [
		4596,
		596
	],
	"./uk.json": [
		7138,
		138
	],
	"./vi.json": [
		1166,
		166
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 5407;
module.exports = webpackAsyncContext;